module.exports = __webpack_public_path__ + "static/media/icon-chat.daa9506f.png";